import React from 'react';
import { HeroSection } from './HeroSection';
import { PromiseSection } from './PromiseSection';
import { DarkQuoteSection } from './DarkQuoteSection';
import { IdentificationSection } from './IdentificationSection';
import { TreeSection } from './TreeSection';
import { GenerationalSection } from './GenerationalSection';
import { ProductSection } from './ProductSection';
import { WhatYouGetSection } from './WhatYouGetSection';
import { BenefitsSection } from './BenefitsSection';
import { TransformationSection } from './TransformationSection';
import { TestimonialSection } from './TestimonialSection';
import { DecisionSection } from './DecisionSection';
import { PricingSection } from './PricingSection';
import { TrustBlock } from './TrustBlock';
import { GuaranteeSection } from './GuaranteeSection';
import { FAQSection } from './FAQSection';
import { FinalCTASection } from './FinalCTASection';
export function LandingPage() {
  return <main className="min-h-screen w-full bg-beige font-inter overflow-x-hidden" data-id="element-109">
      <HeroSection data-id="element-110" />
      <PromiseSection data-id="element-111" />
      <DarkQuoteSection data-id="element-112" />
      <IdentificationSection data-id="element-113" />
      <TreeSection data-id="element-114" />
      <GenerationalSection data-id="element-115" />
      <ProductSection data-id="element-116" />
      <WhatYouGetSection data-id="element-117" />
      <BenefitsSection data-id="element-118" />
      <TransformationSection data-id="element-119" />
      <TestimonialSection data-id="element-120" />
      <DecisionSection data-id="element-121" />
      <PricingSection data-id="element-122" />
      <TrustBlock data-id="element-123" />
      <GuaranteeSection data-id="element-124" />
      <FAQSection data-id="element-125" />
      <FinalCTASection data-id="element-126" />
    </main>;
}